export default __webpack_public_path__ + "static/media/referral.b9556247.png";